import { render, staticRenderFns } from "./-goods-zoom-p.vue?vue&type=template&id=32043e6b&scoped=true"
import script from "./-goods-zoom-p.vue?vue&type=script&lang=js"
export * from "./-goods-zoom-p.vue?vue&type=script&lang=js"
import style0 from "./-goods-zoom-p.vue?vue&type=style&index=0&id=32043e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32043e6b",
  null
  
)

export default component.exports